import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { Subscription } from 'rxjs/internal/Subscription';

import { DateTimeService } from 'src/app/core/services/date-time.service';
import { BaseFormKitComponent } from '../base/base-form-kit.component';
import { BaseFormKitModule } from '../base/base-form-kit.module';
import { TimePickerMaxType } from './types/timepicker-max-type';
import { TimePickerMinType } from './types/timepicker-min.type';

@Component({
    selector: 'timepicker',
    templateUrl: './timepicker.component.html',
    styleUrls: ['../base/base-form-kit.scss', './timepicker.component.scss'],
    imports: [CommonModule, BaseFormKitModule, NgxMaterialTimepickerModule]
})
export class TimepickerComponent extends BaseFormKitComponent {
  //#region properties

  @Input() label: string = 'common.startTime';
  @Input() maxTime: any;
  @Input() minTime: any;
  @Input() minType: TimePickerMinType = 'custom';
  @Input() maxType: TimePickerMaxType = 'custom';
  @Input() value: any | 'now';
  @Input() cancelBtnClass: string;
  @Input() confirmBtnClass: string;
  @Input() isShowToggle: boolean = true;
  listener: any;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.element) {
      const offsetWidth = this.element.nativeElement.offsetWidth;
      if (+offsetWidth < 150) this.isShowToggle = false;
      else this.isShowToggle = true;
    }
  }

  _min;
  _max;

  @Output('value') valueChange = new EventEmitter<any>();
  timepickerSubscription: Subscription;

  //#endregion

  constructor(private element: ElementRef) {
    super();
  }

  ngOnInit() {
    if (this.value) this.value = (<string>this.value).substring(0, 5);
    this.onResize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (
        changes['max'] ||
        changes['min'] ||
        changes['maxType'] ||
        changes['minType'] ||
        changes['minTime'] ||
        changes['maxTime']
      ) {
        this.setMin();
        this.setMax();
      }

      if (changes['value']) {
        this.setValue();
        this.emit();
      }
    } catch (error) {
      console.error('FormField Error => ', error);
    }
  }

  setMin() {
    try {
      switch (this.minType) {
        case 'now':
          this._min = DateTimeService.getTime();
          break;
        case 'firstTime':
          this._min = '00:00';
          break;
        case 'custom':
          this._min = this.minTime ? this.minTime : '00:00';
          break;
      }
    } catch (error) {
      console.error('Timepicker Error => ', error);
    }
  }

  setMax() {
    try {
      switch (this.maxType) {
        case 'now':
          this._max = DateTimeService.getTime();
          break;
        case 'lastTime':
          this._max = '23:59';
          break;
        case 'custom':
          this._max = this.maxTime ? this.maxTime : '23:59';
          break;
      }
    } catch (error) {
      console.error('Timepicker Error => ', error);
    }
  }

  setValue() {
    if (this.value === 'now') this.value = DateTimeService.getCustomTime(1);
  }

  setManualValue(event) {
    try {
      this.value = event.target.value;
      let time = this.value.split(':');
      if (
        Number(time[0]) > 23 ||
        Number(time[0]) < 0 ||
        Number(time[1]) > 59 ||
        Number(time[1]) < 0
      ) {
        this.value = '00:00';
      }
    } catch (error) {
      console.error('Timepicker Error => ', error);
    }
  }

  clearValue() {
    this.value = null;
    this.emit();
  }

  emit() {
    this.valueChange.emit(this.value);
  }

  ngOnDestroy(): void {
    this.timepickerSubscription?.unsubscribe();
    if (this.listener) removeEventListener('resize', this.listener);
  }
}
